/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallExecution200Response
 */
export interface CreateCallExecution200Response {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateCallExecution200Response
     */
    data?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreateCallExecution200Response interface.
 */
export function instanceOfCreateCallExecution200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCallExecution200ResponseFromJSON(json: any): CreateCallExecution200Response {
    return CreateCallExecution200ResponseFromJSONTyped(json, false);
}

export function CreateCallExecution200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallExecution200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function CreateCallExecution200ResponseToJSON(value?: CreateCallExecution200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

